var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { env } from '../environment';
import style from '../css/statistic-tile_css';
let StatisticTile = class StatisticTile extends LitElement {
    constructor() {
        super(...arguments);
        this.title = '';
        this.image = '';
        this.aim = '';
    }
    static get styles() {
        if (env.debug) {
            return css ``;
        }
        return [style];
    }
    firstUpdated() {
        const gs1TextContainer = this.shadowRoot.querySelector('figcaption');
        const childArray = Array.from(this.children);
        childArray.forEach((item) => {
            if (!item.hasAttribute('slot')) {
                gs1TextContainer.appendChild(item);
            }
        });
    }
    render() {
        return html ` ${env.debug
            ? html `<link rel="stylesheet" href="${env.baseUrl}/css/statistic-tile.css" />`
            : html ``}

      <figure class="statistic-tile">
        <header>
          ${this.image != ''
            ? html `<img src="${this.image}" alt="image" />`
            : html ``}
          <h2>${this.title}</h2>
        </header>
        <figcaption></figcaption>
      </figure>`;
    }
};
__decorate([
    property()
], StatisticTile.prototype, "title", void 0);
__decorate([
    property()
], StatisticTile.prototype, "image", void 0);
__decorate([
    property({ reflect: true })
], StatisticTile.prototype, "aim", void 0);
StatisticTile = __decorate([
    customElement('gs1-statistic-tile')
], StatisticTile);
export { StatisticTile };
//# sourceMappingURL=statistic-title.js.map